<template>
    <div class="premium">
      <div class="page-header">
        <i class="back-icon" @click="$router.go(-1)"></i>
      </div>
      <img class="bg" src="@/assets/images/bg/premium-black.png" alt="" />
      <div class="content">
        <div class="desc" v-if="descList.length">
          <div v-for="(item, index) in descList" class="desc-item" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="vip-wrap">
          <div class="vip">
            <div class="vip-item" v-for="(item, index) in vipList" :key="item.id" :class="{'active': activeIdx === index}" @click="activeIdx = index">
            <div class="price-box">
              <p class="price-perday" v-if="item.daily_discount_price || item.daily_original_price"><span>{{ item.currency_symbol }}</span>{{ item.daily_discount_price || item.daily_original_price }}/day</p>
              <p class="price"><span>{{ item.currency_symbol }}</span>{{ item.discount_amount ? priceTransfer(item.discount_amount) : priceTransfer(item.price) }}</p>
            </div>
            <div class="vip-info">
              <p class="title">{{ item.title }} </p>
              <p class="description">{{ item.description }}</p>
            </div>
            <div class="vip-discount-tip" v-if="item.discount_text">{{ item.discount_text }}</div>
          </div>
          </div>
          <div class="btn" v-if="vipList.length" @click="handleBuy">Card Payment</div>
        </div>
        <!-- Exclusive Privilege -->
        <h3 class="column-title">Exclusive Privilege</h3>
        <div class="privilege">
          <div class="privilege-item" v-for="item in privilegeList" :key="item.icon">
            <img :src="require(`@/assets/images/icon/privilege-${item.icon}.png`)" alt="" />
            <span>{{ item.title }}</span>
          </div>
        </div>
        <!-- VIP Featured Comics -->
        <div class="vip-area">
          <h3 class="column-title">VIP Featured Comics</h3>
          <div class="vip-content" v-for="data in vipSuggestList" :key="data.id">
            <TitleBar :title="data.title" @goMore="goMore(data)" />
            <List :data="data.items" :displayStyle="data.style" @goDetail="goDetail" />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import {
  getVip, getVipSuggest, getNovelChapters, getPremiumDetail,
} from '@/api';
import { priceTransfer } from '@/utils';
import defaultAvatarImage from '@/assets/images/icon/avatar.png';
import TitleBar from '@/components/TitleBar';
import List from '@/components/List';

export default {
  components: {
    TitleBar, List,
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState(['userInfo']),
  },
  data() {
    return {
      vipList: [],
      vipSuggestList: [],
      priceTransfer,
      activeIdx: 0,
      privilegeList: [
        { title: 'Unlock All Chapters', icon: '01' },
        { title: 'Editors\' Choice', icon: '02' },
        { title: 'Read In Advance', icon: '03' },
      ],
      effectivedayList: {
        1: '1 DAY',
        7: '1 WEEK',
        30: '1 MONTH',
        180: '6 MONTHS',
        365: '1 YEAR',
      },
      descList: [],
    };
  },
  methods: {
    ...mapActions(['setMoreTitle']),
    async init() {
      const premiumDesc = await getPremiumDetail();
      this.descList = premiumDesc?.data || [];
      const vipList = await getVip();
      this.vipList = vipList?.data || [];
      const vipSuggestList = await getVipSuggest();
      this.vipSuggestList = vipSuggestList?.data || [];
    },
    setDefaultAvatar(e) {
      e.target.src = defaultAvatarImage;
    },
    handleBuy() {
      const productInfo = this.vipList?.[this.activeIdx] || {};
      this.$pay({ ...productInfo, payType: 'subscription' });
    },
    async goDetail(novelId) {
      const res = await getNovelChapters(novelId);
      if (res.code !== 0) return;
      const { id = '' } = res.data[0];
      this.$router.push(`/novel/${novelId}/chapter/${id}`);
    },
    goMore(item) {
      const { id, title } = item;
      this.setMoreTitle(title);
      this.$router.push(`/channel/${id}`);
    },
  },
};
</script>

<style lang="less" scoped>
.premium {
  background: #47e0b5;
  display: flex;
  flex-direction: column;
  .page-header {
    display: flex;
    align-items: center;
    color: @black;
    font-size: @fontLarge;
    font-weight: 700;
    height: 44px;
    padding: 0 16px;
    color: #fff;
    .back-icon {
      margin-right: 10px;
      .iconMixin({
        background-image: url('~@/assets/images/icon/back-white.png');
      });
    }
  }
  .bg {
    width: 360px;
    height: 160px;
  }
  .content {
    background: #fff;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background: linear-gradient(#CBFFE4 0%, #fff 5%);
    border: 1px solid;
    border-image-source: linear-gradient(270deg, #CBFFE4 0%, #CBFFE4 46.84%, #FFFFFF 69.97%, #CBFFE4 84.75%, #CBFFE4 100%);
    backdrop-filter: blur(10px);
    .desc {
      padding: 24px;
      .desc-item {
        background: linear-gradient(90deg, #ceffe6 0%, #f5fcfa 80%);
        color: rgba(0, 178, 80, 1);
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 6px;
        padding: 2px 10px;
        position: relative;
        display: flex;
        align-items: center;
        &::before {
            content: '';
            width: 12px;
            height: 12px;
            flex-shrink: 0;
            background: url('~@/assets/images/icon/icon-list.png') center no-repeat;
            background-size: 100%;
            margin-right: 5px;
        }
      }
    }
    .vip-wrap {
      border-top: 1px solid #a2ffcf;
      padding-bottom: 10px;
      background: #e6fff2;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }
    .vip {
      margin-top: 40px;
      padding: 0 16px;
      .vip-item {
        position: relative;
        padding: 16px 12px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 12px;
        text-align: center;
        margin-bottom: 12px;
        background: linear-gradient(105.92deg, #FCFEFE 6.16%, #F6FDFC 89.3%);
        display: flex;
        align-items: center;
        &.active {
          background: linear-gradient(93.04deg, rgba(223, 249, 244, 0.3) 2.82%, #DFF9F4 98.94%);
          border: 2px solid rgba(33, 210, 187, 1);
        }
        .price-box {
          font-size: @fontLarge;
          color: #0A694B;
          font-weight: 700;
          margin-right: 28px;
          .price {
            font-size: @fontSmall;
            color: #757575;
            font-weight: 400;
          }
        }
        .vip-info {
          text-align: left;
          font-size: 16px;
          color: #757575;
          .title {
            font-size: @fontMedium;
            color: #333;
            letter-spacing: -1px;
            font-weight: 700;
          }
        }
        .vip-discount-tip {
          position: absolute;
          background: linear-gradient(180deg, #30867D 0%, #0A694B 100%);
          color: #fff;
          padding: 5px 10px;
          font-weight: 700;
          border-top-right-radius: 10px;
          border-bottom-left-radius: 10px;
          top: -8px;
          right: -2px;
        }
      }
    }
    .btn {
      height: 44px;
      line-height: 44px;
      font-size: 24px;
      font-weight: 700;
      background: linear-gradient(130.84deg, #3BDC7E 18.93%, #0DCFA9 79.21%);
      margin: 24px 16px 32px;
      border-radius: 49px;
      text-align: center;
      color: #000;
    }
    .column-title {
      font-size: 20px;
      font-weight: 700;
      color: #4ecaa8;
      padding-bottom: 24px;
      text-align: center;
      display: flex;
      justify-content: space-between;
      &::before, &::after {
        content: '';
        width: 68px;
        flex-shrink: 0;
        background: url('~@/assets/images/bg/premium-title.png') center no-repeat;
        background-size: 100%;
      }
      &::after {
        transform: rotateY(180deg);
      }
    }
    .privilege {
      display: flex;
      padding: 0 16px;
      justify-content: space-between;
      margin-bottom: 32px;
      .privilege-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 52px;
          height: 52px;
        }
        span {
          line-height: 24px;
          font-size: 14px;
          text-align: center;
        }
      }
    }
    .vip-area {
      padding: 24px 0;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      background: linear-gradient(180deg, #EDF9F5 35.5%, rgba(255, 255, 255, 0) 100%);
      .vip-content {
        margin: 0 16px 24px;
        padding-top: 20px;
        background: #fff;
        border-radius: 12px;
        /deep/ .list.por-3 .item {
          width: 88px;
        }
      }
    }
  }
}
</style>
